import { render } from "./OpeningBalanceEntry.vue?vue&type=template&id=5897ff00&scoped=true"
import script from "./OpeningBalanceEntry.vue?vue&type=script&lang=js"
export * from "./OpeningBalanceEntry.vue?vue&type=script&lang=js"

import "./OpeningBalanceEntry.vue?vue&type=style&index=0&id=5897ff00&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5897ff00"]])

export default __exports__